<template>
  <div>
    <!-- 头部 -->
    <top></top>
      <!-- logo -->
      <div class="logo">
        <img v-if="bannerArr.length>0" :src="$imgUrl+bannerArr[0].thumb" alt=""/>
      </div>
      <div class="container">
        <div class="exhibitor_detail_tab_box">
          <a v-for="(item,index) in ex_tabs_list" :key="index" class="ex_tabs_item" :class="index==indexs?'activied':''" @click="changeTabs(index)" v-scroll-to="{ el: item.el, duration: 500 }">{{ langSet=='cn'?item.name_cn:item.name_en }}</a>
        </div>
        <div class="ex_d_content">
            <div class="ex_d_top_box" id="section-1" v-if="companyDetail.logo||companyDetail.name_cn||companyDetail.name_en||companyDetail.address||companyDetail.address_en||companyDetail.booth_no">
                <div class="ex_d_left">
                  <img class="top_img" v-if="companyDetail.logo" :src="$imgUrl+companyDetail.logo" alt=""/>
                  <div class="top_txt_box">
                    <!-- lintel_cn -->
                    <div class="top_txt1" v-if="companyDetail.lintel_cn||companyDetail.lintel_en">  {{ langSet == "cn" ? companyDetail.lintel_cn : companyDetail.lintel_en }}</div>
                    <div class="top_txt1 top_txt_cen" v-else>  {{ langSet == "cn" ? companyDetail.name_cn : companyDetail.name_en }}</div>
                    <!-- <div class="top_txt1" v-if="companyDetail.name_cn">{{ companyDetail.name_cn }}</div>
                    <div class="top_txt1 top_txt_cen" v-if="companyDetail.name_en">{{ companyDetail.name_en }}</div> -->
                    <div class="top_txt2 top_txt_cen" v-if="companyDetail.country_area">{{ companyDetail.country_area }}</div>
                    <div class="top_txt2 top_txt_cen" v-if="companyDetail.address||companyDetail.address_en">{{ langSet=='cn'?companyDetail.address:companyDetail.address_en }}</div>
                    <div class="top_txt2 top_txt_cen" v-if="companyDetail.web">{{companyDetail.web }}</div>
                    <div class="top_txt2 top_txt_cen" v-if="companyDetail.telephone">{{ companyDetail.telephone }}</div>
                    <div class="top_txt2 top_txt_cen" v-if="companyDetail.facsimile">{{ companyDetail.facsimile }}</div>
                    <div class="top_txt2 top_txt_cen" v-if="companyDetail.email">{{ companyDetail.email }}</div>
                    <div class="top_txt2 top_txt_cen" v-if="companyDetail.postal_code">{{ companyDetail.postal_code }}</div>
                    <div class="top_txt2" v-if="companyDetail.introduction_cn||companyDetail.introduction_en">{{ langSet=='cn'?companyDetail.introduction_cn:companyDetail.introduction_en }}</div>
                
                  </div>
                </div>
                <div class="ex_top_btn" v-if="companyDetail.booth_no">
                  <img src="../../assets/adress1.jpg" alt="">
                  <span class="booth">{{ langSet=='cn'?'展位号':'Booth Number' }}：{{ companyDetail.booth_no }}</span>
                </div>
            </div>
            <div class="ex_d_prod_box" id="section-2" >
               <div class="ex_d_prod_title">
                  <div class="ex_d_prod_left">{{ langSet=='cn'?'产品中心':'Product Center' }}</div>
                  <div class="more" @click="seeMore">
                    {{$t("home.more")}}<img
                      class="more-icon"
                      src="../../assets/more_icon.png"
                      alt=""
                    />
                  </div>
               </div>
               <div class="prod_tab_box">
                  <el-tabs v-model="search.show_type" @tab-click="proHandleClick">
                    <el-tab-pane v-for="(item,index) in showTypeList" :key="index"  :label="langSet=='cn'?item.name:item.name_en" :name="item.value"></el-tab-pane>
                  </el-tabs>
               </div>
               <div class="ex_list" v-if="companyList.length>0">
                <div class="ex_item" v-for="(item,index) in companyList" :key="index" @click="getproductDetail(item)">
                       <div class="ex_item_top">
                          <div class="ex_title">{{ langSet=='cn'?item.name_cn:item.name_en }}</div>
                          <img class="ex_logo" :src="$imgUrl+item.imgs" alt=""/>
                      </div>
                      <div class="ex_tag_list">
                         <div class="ex_tag_item" v-if="item.type_name1||item.type_name1_en">{{ langSet=='cn'?item.type_name1:item.type_name1_en }}</div>
                         <div class="ex_tag_item" v-if="item.type_name2||item.type_name2_en">{{ langSet=='cn'?item.type_name2:item.type_name2_en }}</div>
                      </div>
                      <div class="ex_line"></div>
                     <div class="ex_bottom_box">
                        <div class="ex_detail">
                            <span>{{ langSet=='cn'?'查看详情':'View Details'}}</span>
                            <img class="more" src="../../assets/more.jpg" alt="" />
                            <img class="more_sel" src="../../assets/more_sel.jpg" alt="" />
                        </div>
                     </div>
                 </div>
               </div>
               <div class="nodata_box" v-else>
                <nodata></nodata>
              </div>

            </div>
            <div class="recruitment_box" id="section-3">
              <div class="ex_d_prod_title">
                  <div class="ex_d_prod_left">{{ langSet=='cn'?'企业招聘':'Enterprise Recruitment'}}</div>
               </div>
               <div class="recruitment_list" v-if="companyRecruitList.length>0">
                  <div class="recruitment_item" v-for="(item,index) in companyRecruitList" :key="index" @click="recruitmentDetails(item)">
                      <div class="recruitment_top_box">
                        <div class="title_box">
                          <img src="../../assets/zp.jpg" alt="">
                          <div class="title">{{ item.position}}</div>
                        </div>
                        <!-- <div class="price"><span>{{ langSet=='cn'?'月薪':'Monthly Salary'}}</span><span>20-25k/{{ langSet=='cn'?'月':'month'}}</span></div> -->
                      </div>
                      <div class="recruitment_content" v-html="item.describe"></div>
                      <div class="recruitment_contact">{{ langSet=='cn'?'投递邮箱':'Drop Off Box'}}：{{ item.delivery }}</div>
                  </div>
               </div>
               <div  v-else>
                <nodata></nodata>
              </div>
            </div>
            <div class="contact_box" id="section-4" v-if="companyDetail.telephone||companyDetail.email||companyDetail.facsimile||companyDetail.postal_code||companyDetail.address||companyDetail.address_en">
              <div class="ex_d_prod_title">
                  <div class="ex_d_prod_left">{{ langSet=='cn'?'联系我们':'Contact Us'}}</div>
               </div>
               <div class="contact_list" >
                  <div class="contact_item" v-if="companyDetail.telephone">
                    <img src="../../assets/call1.jpg" alt=""/>
                    <span>{{ companyDetail.telephone }}</span>
                  </div>
                  <div class="contact_item" v-if="companyDetail.email">
                    <img src="../../assets/call2.jpg" alt=""/>
                    <span>{{ companyDetail.email }}</span>
                  </div>
                  <div class="contact_item" v-if="companyDetail.facsimile">
                    <img src="../../assets/call3.jpg" alt=""/>
                    <span>{{ companyDetail.facsimile }}</span>
                  </div>
                  <div class="contact_item"  v-if="companyDetail.postal_code">
                    <img src="../../assets/call4.jpg" alt=""/>
                    <span>{{ companyDetail.postal_code }}</span>
                  </div>
                  <div class="contact_item" v-if="companyDetail.address||companyDetail.address_en">
                    <img src="../../assets/call5.jpg" alt=""/>
                    <span>{{  langSet=='cn'?companyDetail.address:companyDetail.address_en }}</span>
                  </div>
               </div>
            </div>
        </div>
          
      </div>
    <!-- 底部 -->
    <bottom></bottom>
  </div>
</template>

<script>
import top from "../../components/top.vue";
import bottom from "../../components/bottom.vue";
import nodata from "../../components/nodata.vue";
import {getBanner,geCompanyDetail,getshowType,getproductList,getcompanyRecruitList} from "@/api/api";
export default {
  components: { top, bottom ,nodata},
  name: "exhibitorDetail",
  // 配置title和meta数据
  metaInfo() {
    return {
      title: this.langSet=='cn'?this.companyDetail.name_cn:this.companyDetail.name_en,
      meta: [
        { 
          name: 'description', 
          content: this.langSet=='cn'?this.companyDetail.introduction_cn:this.companyDetail.introduction_en
        }
      ]
    }
  },
  data() {
    return {
      search:{
            page_no:1,
            page_size:5,
            show_type:'',
            company_long_id:''
      },
      total:0,
      loading:false,
      companyList:[],
      langSet:'',
      activeName:'公司简介',
      proActiveName:'BCEIA 2025首发新品',
      bannerArr:[],
      company_long_id:'',
      companyDetail:{},
      showTypeList:[],
      companyRecruitList:[],
      indexs:0,
      ex_tabs_list:[
        {name_cn:'公司简介',name_en:'Company Profile',el:'#section-1'},
        {name_cn:'产品中心',name_en:'Product Center',el:'#section-2'},
        // {name_cn:'公司资料',name_en:'Company Information',el:'#section-3'},
        {name_cn:'企业招聘',name_en:'Enterprise Recruitment',el:'#section-3'},
        {name_cn:'联系我们',name_en:'Contact Us',el:'#section-4'}
      ]
    };
  },
  created() {},
  mounted() {
    this.langSet = localStorage.getItem("languageSet") || "cn";
    this.company_long_id=this.$route.query.company_long_id;
    this.getBannerList()
    this.getCompanyDetail()
    this.getshowType()
    this.getcompanyRecruitList()
   
  },
  methods: {
    changeTabs(index){
         this.indexs=index
    },
     // zhang 跳转企业招聘详情
    recruitmentDetails(item){
       this.$router.push({
          name:'recruitmentDetails',
          query:{
            id:item.id
          }
       })
    },
    // zhang 获取资料下载banner
    getBannerList(){
      let data={
        class:'产品列表',
        lang_type: this.langSet
      }
      getBanner(data).then(res=>{
        if(res.code == 1){
          this.bannerArr=res.data.lists;
        }
          
      }).catch(err=>{
        console.log(err)
      })
    },
    // zhang 获取展商详情
    getCompanyDetail(){
      let data={
        company_long_id:this.company_long_id
      }
      geCompanyDetail(data).then(res=>{
        if(res.code == 1){
          this.companyDetail=res.data;
        }
          
      }).catch(err=>{
        console.log(err)
      })
    },
      // zhang 跳转产品详情
      getproductDetail(item){
         this.$router.push({
           name:'productDetail',
           query:{
            company_long_id:this.company_long_id,
            product_long_id:item.product_long_id
           }
         })
      },
    // zhang 获取产品展示类别
    getshowType(){
        let data={}
        getshowType(data).then(res=>{
            if(res.code == 1){
            this.showTypeList=res.data.lists;
            console.log(this.showTypeList,"this.showTypeList=")
            this.search.show_type=res.data.lists[0].value;
            this.getproductLists()
         }
            
        }).catch(err=>{
            console.log(err)
        })
        },
      // zhang 获取产品列表数据
      getproductLists(){
       this.search.company_long_id=this.company_long_id
       this.loading=true;
       getproductList(this.search).then(res=>{
           if(res.code == 1){
           this.companyList=res.data.lists;
           this.total=res.data.count;
           this.loading=false;
           }
           
       }).catch(err=>{
           console.log(err)
           this.loading=false;
       })
     },
      // zhang 获取企业招聘数据
      getcompanyRecruitList(){
       this.loading=true;
       let data={
        page_no:1,
        page_size:4,
        company_long_id:this.company_long_id
       }
       getcompanyRecruitList(data).then(res=>{
           if(res.code == 1){
           this.companyRecruitList=res.data.lists;
           }
           
       }).catch(err=>{
           console.log(err)
           this.loading=false;
       })
     },
    // 查看更多
    seeMore(){
       this.$router.push({
        name:'productList'
       })
    },
    
    handleClick(tab, event) {
        console.log(tab, event);
    },
    proHandleClick(tab, event) {
      this.search.show_type=tab.name
      this.getproductLists()
    },
  },
};
</script>

<style lang="scss" scoped>
.nodata_box{
  margin-top: 50px;
}
.logo{
    width: 100%;
    height: 600px;
    img{
      width: 100%;
      height: 600px;
    }
}
.container{
  // width: 100%;
  .exhibitor_detail_tab_box{
    width: 100%;
    //  padding: 25px 0 0;
     box-sizing: border-box;
     display: flex;
     justify-content: space-between;
     margin: auto;
     height: 80px;
     line-height: 80px;
     .ex_tabs_item{
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 18px;
      color: #2C2C2E;
      height: 60px;
      cursor: pointer;
      &:hover{
        color: #243889;
      }
     }
     .activied{
      font-weight: 600;
      border-bottom: 5px solid #243889;
     }
  }
  .ex_d_content{
    width: 100%;
    background: #FFFFFF;
    // box-shadow: 0px 2px 28px 0px rgba(0,0,0,0.08);
    padding-bottom: 50px;
    .ex_d_top_box{
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 1280px;
      padding: 50px;
      box-sizing: border-box;
      background: #243889;
      margin: 0 auto;
      .ex_d_left{
        display: flex;
        // align-items: center;
      }
      .ex_top_btn{
        display: flex;
        align-items: center;
        background: rgba(255,255,255,0.3);
        height: 48px;
        line-height: 48px;
        border-radius: 29px;
        padding: 0 21px;
        box-sizing: border-box;
        img{
          width: 13px;
          height: 18px;
        }
        .booth{
          display: inline-block;
          margin-left: 8px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 14px;
          color: #FFFFFF;
        }
      }
      .top_img{
        width: 118px;
        height: 118px;
        background: #FFFFFF;
        border-radius: 20px;
      }
      .top_txt_box{
        margin-left: 20px;
        .top_txt1{
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 16px;
          color: #FFFFFF;
        }
        .top_txt_cen{
          margin: 8px 0;
        }
        .top_txt2{
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: rgba(255,255,255,0.8);
        }
      }
    }
    .contact_box{
      width: 1280px;
      padding: 50px;
      box-sizing: border-box;
      background: rgba(171,181,205,0.1);
      margin: 50px auto 0;
      .ex_d_prod_title{
         margin-bottom: 30px;
         .ex_d_prod_left{
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 18px;
          color: #2C2C2E;
         }
      }
      .contact_list{
        .contact_item{
          display: flex;
          align-items: center;
          margin-bottom:14px;
            img{
              width:18px;
              height: 18px;
            }
            span{
              display: inline-block;
              font-family: PingFangSC, PingFang SC;
              font-weight: 500;
              font-size: 16px;
              color: #2C2C2E;
              margin-left: 8px;
            }
        }
      }
    }
    .recruitment_box{
      width: 1280px;
      padding: 50px;
      box-sizing: border-box;
      background: rgba(171,181,205,0.1);
      margin: 50px auto 0;
      .ex_d_prod_title{
         margin-bottom: 30px;
         .ex_d_prod_left{
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 18px;
          color: #2C2C2E;
         }
      }
      .recruitment_list{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .recruitment_item{
            width: -webkit-calc((100% - 20px*2)/ 2);
            width: calc((100% - 23px*2)/ 2);
            padding: 22px 25px 20px 20px;
            box-sizing: border-box;
            background: #FFFFFF;
            margin: 0 20px 20px 0;
        }
        .recruitment_top_box{
          display: flex;
          justify-content: space-between;
          margin-bottom: 10px;
          .title_box{
            position: relative;
            width: 50%;
            margin-top: -8px;
            img{
              width: 26px;
              height: 26px; 
            }
            .title{
              position: absolute;
              top: 8px;
              left: 10px;
            }
          }
          .title{
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 18px;
            color: #2C2C2E;
          }
          .price{
            display: flex;
            align-items: center;
          }
          .price span:nth-child(1){
              display: inline-block;
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 16px;
              color: #2C2C2E;
          }
          .price span:nth-child(2){
              display: inline-block;
              font-family: PingFangSC, PingFang SC;
              font-weight: 600;
              font-size: 18px;
              color: #FF6A0A;
              margin-left: 8px;
          }
        }
        .recruitment_content{
          width: 100%;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #757575;
          margin-bottom: 15px;
          line-height: 20px;
        }
        .recruitment_contact{
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 16px;
          color: #2C2C2E;
        }
      }
    }
    .ex_d_prod_box{
      width: 1280px;
      padding: 50px;
      box-sizing: border-box;
      background: rgba(171,181,205,0.1);
      margin: 50px auto 0;
      .ex_d_prod_title{
         display: flex;
         justify-content: space-between;
         margin-bottom: 30px;
         .ex_d_prod_left{
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 18px;
          color: #2C2C2E;
         }
         .more {
            font-size: 14px;
            color: #757575;
            cursor: pointer;
            text-align: right;
            line-height: 28px;
            &:hover{
              color: #243889;
            }
            .more-icon {
              margin-bottom: -2px;
              width: 16px;
              margin-left: 14px;
            }
          }
      }
      .ex_list{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .ex_item{
            width: -webkit-calc((100% - 23px*5)/ 5);
            width: calc((100% - 23px*5)/ 5);
          
            background: #FFFFFF;
            margin: 0 20px 20px 0;
            .ex_item_top{
               padding: 15px;
               box-sizing: border-box;
               .ex_title{
                width: 100%;
                line-height: 22px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 500;
                font-size: 16px;
                color: #2C2C2E;
              }
              .ex_logo{
                width: 188px;
                height: 105px;
                margin: 10px 0;
              }
            }
            .ex_tag_list{
               display: flex;
               flex-wrap: wrap;
               padding: 15px;
               box-sizing: border-box;
               .ex_tag_item{
                width: 64px;
                // height: 21px;
                line-height: 21px;
                text-align: center;
                background: rgba(36,56,137,0.1);
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 12px;
                color: #243889;
                margin-right: 8px;
                margin-bottom: 15px;
               }
            }
            .ex_line{
              width: 100%;
              height: 1px;
              background: #EEEEEE;
            }
         
            .img{
              width: 100%;
              height: 105px;
            }
            .ex_address{
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #757575;
                margin-top: 5px;
            }
            .ex_bottom_box{
                margin-top: 15px;
                padding-bottom: 15px;
                padding-left: 15px;
                box-sizing: border-box;
                display: flex;
                justify-content: space-between;
                .ex_booth{
                    display: flex;
                    img{
                        width: 13px;
                        height: 18px; 
                    }
                    span{
                        display: inline-block;
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 400;
                        font-size: 16px;
                        color: #2C2C2E;
                        margin-left: 8px;
                    }
                }
                .ex_detail{
                    span{
                        display: inline-block;
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 400;
                        font-size: 14px;
                        color: #757575;
                    }
                    img{
                        width: 7px;
                        height: 10px;
                        margin-left: 6px;
                    }
                    .more_sel{
                      display: none;
                    }
                }
            }
        }
        .ex_item:hover{
            border: 1px solid #243889;
            .ex_detail{
                span{
                color: #243889;
              }
              .more{
                display: none;
              }
                .more_sel{
                    display: inline-block;
                  }
              }

        }
    }
    .ex_list::after{
        content: "";
        flex: auto;
    }
      
    }
  }
}

@media only screen and (max-width: 1280px) {
  .ex_tabs_item{
    font-size: 18px !important;
    height:52px !important;
  }
  .activied{
    border-bottom: 3px solid #243889 !important;
  }
  .ex_d_top_box{
    padding: 20px !important;
    // flex-wrap: wrap;
  }
  .ex_d_prod_box{
    padding: 20px !important;
  }
  .ex_top_btn{
    background: transparent !important;
    line-height: initial !important;
    position: absolute;
    bottom: 2px !important;
    right: 0;
  }
  .ex_d_prod_left{
    font-size: 18px !important;
    line-height: 28px !important;
  }
  .ex_item{
    width: 213px !important;
    .ex_logo{
      width: 100% !important;
      height: 83px !important;
    }
  }
  .recruitment_box{
    padding: 20px !important;
  }
  .recruitment_item{
    width: 100% !important;
  }
  .more{
    font-size: 14px !important;
    .more-icon{
      width: 14px !important;
      margin-left: 8px !important;
    }
  }
  .top_img{
    width: 80px  !important;;
    height: 80px !important;
  }
  .top_txt1{
    font-size: 18px !important;
  }
  .top_txt2{
    font-size: 12px !important;
  }
  .booth{
    font-size: 12px !important;
  }
  .logo{
    width: 100%;
    height:500px;
    img{
      width: 100%;
      height:500px;
    }
}
  .ex_d_top_box{
    width: 100% !important;
    position: relative;
  }
  .ex_d_prod_box{
    width: 100% !important;
  }
  .recruitment_box{
    width: 100% !important;
  }
  .contact_box{
    width: 100% !important;
  }
}
@media only screen and (max-width: 1000px) {
  .ex_tabs_item{
    font-size: 16px !important;
    height:52px !important;
  }
  .activied{
    border-bottom: 3px solid #243889 !important;
  }
  .ex_d_top_box{
    padding: 20px !important;
    // flex-wrap: wrap;
  }
  .ex_d_prod_box{
    padding: 20px !important;
  }
  .ex_top_btn{
    background: transparent !important;
    line-height: initial !important;
    position: absolute;
    bottom: 2px !important;
    right: 0;
  }
  .ex_d_prod_left{
    font-size: 18px !important;
    line-height: 28px !important;
  }
  .ex_item{
    width: 200px !important;
    .ex_logo{
      width: 100% !important;
      height: 83px !important;
    }
  }
  .recruitment_box{
    padding: 20px !important;
  }
  .recruitment_item{
    width: 100% !important;
  }
  .more{
    font-size: 14px !important;
    .more-icon{
      width: 14px !important;
      margin-left: 8px !important;
    }
  }
  .top_img{
    width: 80px  !important;;
    height: 80px !important;
  }
  .top_txt1{
    font-size: 18px !important;
  }
  .top_txt2{
    font-size: 12px !important;
  }
  .booth{
    font-size: 12px !important;
  }
  .logo{
    width: 100%;
    height:350px;
    img{
      width: 100%;
      height:350px;
    }
}
  .ex_d_top_box{
    width: 100% !important;
    position: relative;
  }
  .ex_d_prod_box{
    width: 100% !important;
  }
  .recruitment_box{
    width: 100% !important;
  }
  .contact_box{
    width: 100% !important;
  }
}
@media only screen and (max-width: 767px) {
  .ex_tabs_item{
    font-size: 16px !important;
    height:52px !important;
  }
  .recruitment_contact{
    font-size: 14px;
  }
  .activied{
    border-bottom: 3px solid #243889 !important;
  }
  .ex_d_top_box{
    padding: 20px !important;
    // flex-wrap: wrap;
  }
  .ex_d_prod_box{
    padding: 20px !important;
  }
  .ex_top_btn{
    background: transparent !important;
    line-height: initial !important;
    position: absolute;
    bottom: 2px !important;
    right: 0;
  }
  .ex_d_prod_left{
    font-size: 16px !important;
    line-height: 28px !important;
  }
  .ex_item{
    width: 200px !important;
    .ex_logo{
      width: 100% !important;
      height: 83px !important;
    }
  }
  .recruitment_box{
    padding: 20px !important;
  }
  .recruitment_item{
    width: 100% !important;
  }
  .recruitment_top_box .title{
    font-size: 16px;
  }
  .more{
    font-size: 12px !important;
    .more-icon{
      width: 14px !important;
      margin-left: 8px !important;
    }
  }
  .container .ex_d_content .contact_box .contact_list .contact_item span{
    font-size: 12px;
  }
  .top_img{
    width: 70px  !important;;
    height: 70px !important;
  }
  .top_txt1{
    font-size: 16px !important;
  }
  .top_txt2{
    font-size: 12px !important;
  }
  .booth{
    font-size: 12px !important;
  }
  .logo{
    width: 100%;
    height:121px;
    margin-top: 0.88rem;
    img{
      width: 100%;
      height: 121px;
    }
}
  .ex_d_top_box{
    width: 100% !important;
    position: relative;
  }
  .ex_d_prod_box{
    width: 100% !important;
  }
  .recruitment_box{
    width: 100% !important;
  }
  .contact_box{
    width: 100% !important;
  }
}
</style>
<style lang="scss">
   .exhibitor_detail_box .ex_d_tab_list{
      width: 1280px;
      margin: 0 auto;
   }
   .exhibitor_detail_tab_box .el-tabs__nav-wrap::after{
    background: transparent;
   }
   .exhibitor_detail_tab_box .el-tabs__item{
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 22px;
        color: #2C2C2E;
        height: 48px;
        line-height: 48px;
        padding: 0 0 0 210px;
   }
   .exhibitor_detail_tab_box .el-tabs__item:nth-last-child(1){
      padding-right: 0 !important;
   }
   .exhibitor_detail_box .el-tabs__item.is-active{
    color: #243889;
   }
   .exhibitor_detail_tab_box .el-tabs__active-bar{
    width: 88px;
    height: 5px;
    background: #243889;
   }
   .exhibitor_detail_tab_box .el-tabs__header{
    width: 100%;
   }
   .exhibitor_detail_tab_box .el-tabs__nav-scroll{
    width: 100%;
   }
   .exhibitor_detail_tab_box .el-tabs__nav{
    width: 100%;
   }

   .prod_tab_box .el-tabs__item{
    padding: 0 0 0 115px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #2C2C2E;
   }
   .prod_tab_box .el-tabs__active-bar{
    height: 3px;
    background: #243889;
   }
   @media only screen and (max-width: 767px) {
    .prod_tab_box .el-tabs__item{
      font-size: 12px !important;
      padding: 0 0 0 28px !important;
    }
}
</style>